var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.8 504.8",
    style: {
      enableBackground: "new 0 0 504.8 504.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7EEF2"
    },
    d: "M464,231.2c0,10.4-8.8,12.8-19.2,12.8H60c-10.4,0-19.2-1.6-19.2-12.8v-212C40.8,8.8,49.6,0,60,0h384 c10.4,0,19.2,8.8,19.2,19.2v212H464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7D5DD"
    },
    d: "M464,492c0,10.4-8.8,12.8-19.2,12.8H60c-10.4,0-19.2-1.6-19.2-12.8V280c0-10.4,8.8-19.2,19.2-19.2 h384c10.4,0,19.2,8.8,19.2,19.2v212H464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF6F9"
    },
    d: "M464,481.6c0,10.4-8.8,12.8-19.2,12.8H60c-10.4,0-19.2-1.6-19.2-12.8v-212c0-10.4,8.8-19.2,19.2-19.2 h384c10.4,0,19.2,8.8,19.2,19.2v212H464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M464,236.8c0,10.4-8.8,12.8-19.2,12.8H60c-10.4,0-19.2-1.6-19.2-12.8v-212c0-10.4,8.8-19.2,19.2-19.2 h384c10.4,0,19.2,8.8,19.2,19.2v212H464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7EEF2"
    },
    d: "M60,250.4h384c10.4,0,19.2,8.8,19.2,19.2v212c0,10.4-8.8,12.8-19.2,12.8H60"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E3EA"
    },
    d: "M60,250.4h384c10.4,0,19.2,8.8,19.2,19.2v212c0,10.4-8.8,12.8-19.2,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8CAD1"
    },
    d: "M439.2,415.2c0,9.6-0.8,11.2-10.4,11.2H74.4c-9.6,0-10.4-1.6-10.4-11.2V284c0-9.6,0.8-11.2,10.4-11.2 h354.4c9.6,0,10.4,1.6,10.4,11.2L439.2,415.2L439.2,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7D5DD"
    },
    d: "M439.2,416c0,8.8-0.8,10.4-10.4,10.4H74.4c-9.6,0-10.4-1.6-10.4-10.4V288.8c0-8.8,0.8-10.4,10.4-10.4 h354.4c9.6,0,10.4,1.6,10.4,10.4L439.2,416L439.2,416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M100,293.6c0,0.8-0.8,0.8-0.8,0.8H80c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M124.8,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8H124 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M149.6,293.6c0,0.8,0,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M175.2,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M200,293.6c0,0.8-0.8,0.8-0.8,0.8H180c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M224.8,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8H224 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M250.4,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M275.2,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M300,293.6c0,0.8-0.8,0.8-0.8,0.8H280c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M325.6,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8H324 c0.8,0,0.8,0.8,0.8,0.8v8.8H325.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M350.4,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M375.2,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M400.8,293.6c0,0.8-0.8,0.8-0.8,0.8h-20c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8v8.8H400.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M426.4,293.6c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-8.8c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V293.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M97.6,316.8c0,0.8-0.8,2.4-2.4,2.4H80c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M121.6,316.8c0,0.8-0.8,2.4-2.4,2.4H104c-0.8,0-1.6-0.8-1.6-2.4v-15.2c0-0.8,0.8-2.4,1.6-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M145.6,316.8c0,0.8-0.8,2.4-2.4,2.4H128c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M170.4,316.8c0,0.8-0.8,2.4-2.4,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4H168 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M194.4,316.8c0,0.8-0.8,2.4-1.6,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,1.6,0.8,1.6,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M219.2,316.8c0,0.8-0.8,2.4-2.4,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M243.2,316.8c0,0.8-0.8,2.4-2.4,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M268,316.8c0,0.8-0.8,2.4-2.4,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M292,316.8c0,0.8-0.8,2.4-2.4,2.4h-15.2c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M316.8,316.8c0,0.8-0.8,2.4-1.6,2.4H300c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,1.6,0.8,1.6,2.4V316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M340.8,316.8c0,0.8-0.8,2.4-2.4,2.4H324c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,2.4,0.8,2.4,2.4v15.2H340.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M365.6,316.8c0,0.8-0.8,2.4-1.6,2.4h-16c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h15.2 c0.8,0,1.6,0.8,1.6,2.4v15.2H365.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M389.6,316.8c0,0.8-0.8,2.4-2.4,2.4H372c-0.8,0-2.4-0.8-2.4-2.4v-15.2c0-0.8,0.8-2.4,2.4-2.4h16 c0.8,0,2.4,0.8,2.4,2.4v15.2H389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M423.2,300h-12H408h-12c-0.8,0-1.6,0.8-1.6,2.4v15.2c0,0.8,0.8,2.4,1.6,2.4h12h3.2h12 c0.8,0,2.4-0.8,2.4-2.4v-15.2C425.6,300.8,424.8,300,423.2,300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M406.4,326.4c0-0.8,0.8-2.4,2.4-2.4H424c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M382.4,326.4c0-0.8,0.8-2.4,2.4-2.4H400c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M357.6,326.4c0-0.8,0.8-2.4,1.6-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M333.6,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4H336 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M308.8,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M284.8,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M260,326.4c0-0.8,0.8-2.4,1.6-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M236,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4L236,326.4L236,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M211.2,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M187.2,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M162.4,326.4c0-0.8,0.8-2.4,2.4-2.4H180c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4L162.4,326.4L162.4,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M138.4,326.4c0-0.8,0.8-2.4,2.4-2.4H156c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-16 c-0.8,0-2.4-0.8-2.4-2.4v-15.2H138.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M113.6,326.4c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4H116 c-0.8,0-2.4-0.8-2.4-2.4V326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M80,344h12h3.2h12c0.8,0,2.4-0.8,2.4-2.4v-15.2c0-0.8-0.8-2.4-2.4-2.4h-12H92H80 c-0.8,0-2.4,0.8-2.4,2.4v15.2C78.4,342.4,79.2,344,80,344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M364.8,350.4c0-0.8,0.8-1.6,1.6-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M340,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M316,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M291.2,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M267.2,350.4c0-0.8,0.8-1.6,2.4-1.6H284c0.8,0,1.6,0.8,1.6,1.6v15.2c0,0.8-0.8,2.4-1.6,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4v-15.2H267.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M242.4,350.4c0-0.8,0.8-1.6,1.6-1.6h16c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4v-15.2H242.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M218.4,350.4c0-0.8,0.8-1.6,2.4-1.6H236c0.8,0,1.6,0.8,1.6,1.6v15.2c0,0.8-0.8,2.4-1.6,2.4h-16 c-0.8,0-2.4-0.8-2.4-2.4v-15.2H218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M193.6,350.4c0-0.8,0.8-1.6,1.6-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4H196 c-0.8,0-1.6-0.8-1.6-2.4v-15.2H193.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M169.6,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,1.6,0.8,1.6,1.6v15.2c0,0.8-0.8,2.4-1.6,2.4H172 c-0.8,0-2.4-0.8-2.4-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M144.8,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M120.8,350.4c0-0.8,0.8-1.6,2.4-1.6h15.2c0.8,0,2.4,0.8,2.4,1.6v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4C120.8,365.6,120.8,350.4,120.8,350.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M390.4,368h14.4h4h14.4c1.6,0,2.4-0.8,2.4-2.4v-15.2c0-0.8-0.8-1.6-2.4-1.6h-14.4h-4h-14.4 c-1.6,0-2.4,0.8-2.4,1.6v15.2C388,367.2,389.6,368,390.4,368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M80.8,368h14.4h4h14.4c1.6,0,2.4-0.8,2.4-2.4v-15.2c0-0.8-0.8-1.6-2.4-1.6H99.2h-4H80.8 c-1.6,0-2.4,0.8-2.4,1.6v15.2C78.4,367.2,79.2,368,80.8,368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M352,375.2c0-0.8,0.8-2.4,1.6-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M328,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M303.2,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M279.2,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M254.4,375.2c0-0.8,0.8-2.4,2.4-2.4H272c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M230.4,375.2c0-0.8,0.8-2.4,2.4-2.4H248c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M205.6,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4H208 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M181.6,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4H184 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M156.8,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M132.8,375.2c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V375.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M80.8,392.8h13.6h4h28c1.6,0,2.4-0.8,2.4-2.4v-15.2c0-0.8-0.8-2.4-2.4-2.4h-28h-4H80.8 c-1.6,0-2.4,0.8-2.4,2.4v15.2C78.4,392,79.2,392.8,80.8,392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M377.6,392.8H396h4h23.2c1.6,0,2.4-0.8,2.4-2.4v-15.2c0-0.8-0.8-2.4-2.4-2.4H400h-4h-18.4 c-1.6,0-2.4,0.8-2.4,2.4v15.2C375.2,392,376.8,392.8,377.6,392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M304,400c0-0.8,0.8-2.4,2.4-2.4h19.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-19.2 c-0.8,0-2.4-0.8-2.4-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M151.2,400c0-0.8,0.8-2.4,2.4-2.4h19.2c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4h-19.2 c-0.8,0-2.4-0.8-2.4-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M126.4,400c0-0.8,0.8-2.4,2.4-2.4H144c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M332.8,400c0-0.8,0.8-2.4,2.4-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4h-15.2 c-0.8,0-2.4-0.8-2.4-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M101.6,400c0-0.8,0.8-2.4,1.6-2.4h15.2c0.8,0,1.6,0.8,1.6,2.4v15.2c0,0.8-0.8,2.4-1.6,2.4h-15.2 c-0.8,0-1.6-0.8-1.6-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M77.6,400c0-0.8,0.8-2.4,1.6-2.4h15.2c0.8,0,2.4,0.8,2.4,2.4v15.2c0,0.8-0.8,2.4-2.4,2.4H79.2 c-0.8,0-1.6-0.8-1.6-2.4V400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M296.8,397.6h-6.4h-9.6H272h-15.2H248h-15.2H224h-15.2h-24c-0.8,0-2.4,0.8-2.4,2.4v15.2 c0,0.8,0.8,2.4,2.4,2.4h24H224h8.8H248h8.8H272h8.8h9.6h6.4c0.8,0,1.6-0.8,1.6-2.4V400C298.4,398.4,297.6,397.6,296.8,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M377.6,416c0,0.8-0.8,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-6.4c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M402.4,416c0,0.8,0,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-6.4c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M402.4,404.8c0,0.8,0,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-6.4c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V404.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M426.4,416c0,0.8,0,0.8-0.8,0.8h-19.2c-0.8,0-0.8-0.8-0.8-0.8v-6.4c0-0.8,0.8-0.8,0.8-0.8h19.2 c0.8,0,0.8,0.8,0.8,0.8V416z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7D5DD"
    },
    d: "M301.6,483.2c0,1.6-1.6,3.2-3.2,3.2h-92.8c-1.6,0-3.2-1.6-3.2-3.2v-48c0-1.6,1.6-3.2,3.2-3.2h92 c1.6,0,3.2,1.6,3.2,3.2v48H301.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E3EA"
    },
    d: "M301.6,483.2c0,1.6-1.6,3.2-3.2,3.2h-92.8c-1.6,0-3.2-1.6-3.2-3.2v-44c0-1.6,1.6-3.2,3.2-3.2h92 c1.6,0,3.2,1.6,3.2,3.2v44H301.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E7EEF2"
    },
    cx: 448,
    cy: 266.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1FEADB"
    },
    d: "M446.4,225.6V38.4c0-9.6,0-17.6-9.6-17.6H67.2c-9.6-0.8-9.6,7.2-9.6,17.6v188h388.8V225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15CCCC"
    },
    d: "M446.4,225.6V38.4c0-9.6,0-17.6-9.6-17.6H67.2c-9.6-0.8-9.6,7.2-9.6,17.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1AB5B5"
    },
    d: "M436.8,20H67.2c-9.6,0-9.6,8-9.6,18.4v16.8c0-9.6,0-17.6,9.6-17.6H436c9.6,0,9.6,8,9.6,17.6V38.4 C446.4,28,446.4,20,436.8,20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#08446D"
    },
    d: "M410.4,262.4c0,1.6-1.6,2.4-4,2.4H97.6c-2.4,0-4-0.8-4-2.4v-12.8c0-1.6,1.6-2.4,4-2.4h308.8 c2.4,0,4,0.8,4,2.4V262.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M93.6,248.8c0-1.6,1.6-2.4,4-2.4h308.8c2.4,0,4,0.8,4,2.4v12.8c0,1.6-1.6,2.4-4,2.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8E3EA"
    },
    points: "252,240.8 256.8,245.6 260,242.4 252,234.4 244,242.4 247.2,245.6 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#27D68A"
    },
    cx: 252,
    cy: 13.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15AF83"
    },
    d: "M252,10.4c1.6,0,3.2,1.6,3.2,3.2s-1.6,3.2-3.2,3.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#CFFFEF"
    },
    cx: 250.373,
    cy: 12.782,
    rx: 0.8,
    ry: 0.8
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.966722b37aec279eec357c2df8d1d564.svg";
export { ForwardRef as ReactComponent };